import { AxiosResponse } from 'axios';
import React from 'react';
import SelectSearch, { SelectedOptionValue } from 'react-select-search';
import { Unsubscribe } from 'redux';
import identityStorage from '../../../infrastructure/authorization/identityStorage';
import reportConfigStorage from '../../../infrastructure/common/reportConfig';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import dataSourceKind from '../../../infrastructure/constants/dataSourceKind';
import operandType from '../../../infrastructure/constants/functions/operandType';
import writeUserRoles from '../../../infrastructure/constants/identity/writeUserRoles';
import { endpointFilterType } from '../../../infrastructure/constants/report/endpointFilterType';
import { reportType } from '../../../infrastructure/constants/reportType';
import ButtonContext from '../../../infrastructure/helpers/common/ButtonContext';
import copyArray from '../../../infrastructure/helpers/common/copyArray';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import navigationHelper from '../../../infrastructure/helpers/common/navigation/navigation';
import reorderHelper from '../../../infrastructure/helpers/common/reorderHelper';
import sortingHelper from '../../../infrastructure/helpers/common/sortingHelper';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import aggregationHelper from '../../../infrastructure/helpers/functions/aggregation/aggregationHelper';
import enrichmentHelper from '../../../infrastructure/helpers/functions/enrichment/enrichmentHelper';
import lookupDataSourceHelper from '../../../infrastructure/helpers/functions/lookup/lookupDataSourceHelper';
import operandHelper from '../../../infrastructure/helpers/functions/operand/operandHelper';
import reportLogicLocationHelper from '../../../infrastructure/helpers/functions/report/reportLogicLocationHelper';
import history from '../../../infrastructure/helpers/react/history';
import editReportConfigHelper from '../../../infrastructure/helpers/report/editReportConfigHelper';
import reportConfigNavigation from '../../../infrastructure/helpers/report/navigation/reportConfigNavigation';
import { htmlIds } from '../../../infrastructure/helpers/report/navigation/reportConfigNavigation.HtmlIds';
import reportConfigCountHelper from '../../../infrastructure/helpers/report/reportConfigCountHelper';
import lockManager from '../../../infrastructure/locking/lockManager';
import ReportCollections from '../../../infrastructure/types/Functions/ReportCollections';
import ObjectIndexer from '../../../infrastructure/types/ObjectIndexer';
import actions from '../../../store/actions';
import selectorsStore from '../../../store/selectorsStore';
import store from '../../../store/store';
import Assignment from '../../../types/functions/Assignment/Assignment';
import Condition from '../../../types/functions/Condition/Condition';
import locationType from '../../../types/functions/Location/LocationType';
import ReportLogicLocation from '../../../types/functions/Location/ReportLogicLocation';
import Lookup from '../../../types/functions/Lookup';
import Operand from '../../../types/functions/Operand/Operand';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import IngestionConfigOption from '../../../types/ingestion/IngestionConfigOption';
import AccuracyValidation from '../../../types/report/AccuracyValidation';
import ActionType from '../../../types/report/ActionType';
import Aggregation from '../../../types/report/Aggregation';
import AggregationFilter from '../../../types/report/AggregationFilter';
import AnnaDsbSelector from '../../../types/report/AnnaDsbSelector';
import ComponentChangeState from '../../../types/report/ComponentChangeState';
import ComponentType from '../../../types/report/ComponentType';
import CustomDataSourceFields from '../../../types/report/CustomDataSourceFields';
import DataSourceField from '../../../types/report/DataSourceField';
import Dictionary from '../../../types/report/Dictionary';
import DictionaryField from '../../../types/report/DictionaryField';
import EndpointFilter from '../../../types/report/EndpointFilter';
import FirdsInstrumentSelector from '../../../types/report/FirdsInstrumentSelector';
import IdNameAndNumber from '../../../types/report/IdNameAndNumber';
import MatchingKey from '../../../types/report/MatchingKey';
import Mode from '../../../types/report/Mode';
import NavigateToComponentNumber from '../../../types/report/NavigateToComponentNumber';
import NumberType from '../../../types/report/NumberType';
import OptionalModule from '../../../types/report/OptionalModule';
import RefDataSource from '../../../types/report/RefDataSource';
import ReportCase from '../../../types/report/ReportCase';
import ReportCaseField from '../../../types/report/ReportCaseField';
import ReportConfig from '../../../types/report/ReportConfig';
import ReportConfigComponentLock from '../../../types/report/ReportConfigComponentLock';
import ReportConfigCounts from '../../../types/report/ReportConfigCounts';
import ReportConfigLockResponse from '../../../types/report/ReportConfigLockResponse';
import ReportConfigNavigationPayload from '../../../types/report/ReportConfigNavigationPayload';
import ReportFieldDefinition from '../../../types/report/ReportFieldDefinition';
import ReportFilter from '../../../types/report/ReportFilter';
import ReportVariable from '../../../types/report/ReportVariable';
import Selector from '../../../types/report/Selector';
import SelectorsState from '../../../types/report/SelectorsState';
import UserDefinedFunction from '../../../types/report/UserDefinedFunction';
import UserDefinedFunctionParameter from '../../../types/report/UserDefinedFunctionParameter';
import { TransferModel } from '../../../types/transfer/ComponentsForTransfer';
import ChangeLogNameAndCommentModal from '../../Common/ChangeLog/ChangeLogNameAndCommentModal';
import ErrorMessage from '../../Common/ErrorMessage/ErrorMessage';
import messageHelper from '../../Common/Message/MessageHelper';
import InformationModal from '../../Common/Modals/InformationModal/InformationModal';
import { configIsWaitingApprovalMessage, configIsWaitingApprovalTitle, leavePageMessage, leavePageTitle } from '../../Common/NavigationPrompt/NavigationPrompt.Helpers';
import QuickActions from '../../Common/QuickActions/QuickActions';
import MoreArgumentsModal from '../../Functions/Arguments/MoreArgumentsModal';
import NavigateToItem from '../../Functions/Condition/Types/NavigateToItem';
import OperandModal from '../../Functions/Operand/Modal/OperandModal';
import CopyAggregationModal from '../Aggregation/CopyAggregationModal/CopyAggregationFieldModal';
import { buildOptions } from '../Common/ReportQuickActions.Helpers';
import { getModules, isDataSourceReferencedInCurrentConfig } from '../DataSources/DataSourceForm.Helpers';
import CopyReportFieldModal from '../Enrichment/CopyReportFieldModal/CopyReportFieldModal';
import { getGlobalModuleDetaSourceValues } from '../GlobalModule/GlobalModule.Helpers';
import ReportConfigEditor from '../ReportConfigEditor/ReportConfigEditor';
import CopyValidationModal from '../Validation/CopyValidationModal/CopyValidationModal';
import CopyVariableModal from '../Variable/CopyVariableModal/CopyVariableModal';
import { allowEdit, createSelectSearchOption, getLockedMessage, isResetRequired, resetNumbers, setAggregationFieldAssignment, setAssignment, setCondition, setDictionaryAssignment, setReporCasetFieldAssignment, setSelectorAssignmentByKey, updateFunctionReferencesOnDelete } from './ReportEditPage.Helpers';
import './ReportEditPage.scss';
import validate from './ReportEditPage.Validation';
import { addGlobalModuleConfig, addGlobalModuleDataSources, getConfigById, getCounts, getCustomDataSourceFields, getDataSourceOptions, getEmptyReportPageContext, getReportDataSources, getReportFields, isPendingApproval, seedCustomDataSourceFields, seedReportDataSourceOptions, seedReportDataSources, seedReportFields } from './ReportPage/ReportPage.Helpers';
import ReportPageContext from './ReportPage/ReportPageContext';
import ReportPageState from './ReportPage/ReportPageState';
import ReportTransferModal from './ReportTransferModal';
import ReportTransferModalState from './ReportTransferModalState';
import Method from '../../../types/report/LookupMethod';
import conditionHelper from '../../../infrastructure/helpers/functions/condition/conditionHelper';

export interface State extends ReportPageState {
    isWaiting: boolean;
    counts: ReportConfigCounts;
    aggregationNumber: number | null;
    isinSelectorNumber: number | null;
    leiSelectorNumber: number | null;
    exchangeRatesSelectorNumber: number | null;
    caseNumber: number | null;
    clipboard: ReportLogicLocation | null;
    lockMessage: string | null;
    errors: ButtonContext[];
    quickActionNumber: string;
    showComponentLockedPopup: boolean;
    editedComponents: ReportConfigComponentLock[] | [],
    reportConfigIntervalId: any,
    annaDsbUpiEnrichmentNumber: number | null,
    lseNumber: number | null,
    fcaRegulatedEntitiesNumber: number | null,
    annaDsbUpiNumber: number | null
    dictionaryNumber: number | null
    functionNumber: number | null,
    firdsFcaInstrumentSelectorNumber: number | null,
    firdsEsmaInstrumentSelectorNumber: number | null,
    showInformationModal: boolean,
    isReadOnly: boolean,
    warningModalMessage: string,
    warningModalTitle: string,
    onWarningOkClick: () => void,
    changesName: string,
    changesComment: string,
    showChangeNameAndComment: boolean,
    shouldExit: boolean,
    symbolSelectorNumber: number | null;
}

class ReportEditPage extends React.Component<any, State> {

    private id: number;
    private section: string;
    private htmlid: string;
    private mainComponentNumber: string;
    private query: ObjectIndexer<string>;
    private isValidQueryParam: boolean;
    private pageContext: ReportPageContext;

    private unsubscribe: Unsubscribe | undefined;
    private unsubscribeSelectComponent: Unsubscribe | undefined;
    private unsubscribeTransferConfirm: Unsubscribe | undefined;
    private unsubscribeBracketSelect: Unsubscribe | undefined;
    private unsubscribeAggregationSelect: Unsubscribe | undefined;
    private oneMinutesInMileseconds = 60000;
    private lockIntervalId: any = 0;

    constructor(props: any) {
        super(props);


        this.query = urlHelper.deserializeQuery(history.location.search);

        this.section = this.query['section'];

        this.htmlid = this.query['htmlid'];

        this.mainComponentNumber = this.query['number'];

        this.id = parseInt(this.query['id']);

        this.isValidQueryParam = typeHelper.isNumber(this.id);

        this.pageContext = getEmptyReportPageContext();

        this.state = {
            isWaiting: true,
            reportConfig: this.pageContext.config,
            counts: reportConfigCountHelper.getEmpty(),
            aggregationNumber: null,
            isinSelectorNumber: null,
            leiSelectorNumber: null,
            exchangeRatesSelectorNumber: null,
            annaDsbUpiEnrichmentNumber: null,
            lseNumber: null,
            fcaRegulatedEntitiesNumber: null,
            annaDsbUpiNumber: null,
            caseNumber: null,
            dictionaryNumber: null,
            functionNumber: null,
            clipboard: null,
            lockMessage: null,
            errors: [],
            quickActionNumber: '',
            showComponentLockedPopup: false,
            editedComponents: [],
            reportConfigIntervalId: null,
            firdsFcaInstrumentSelectorNumber: null,
            firdsEsmaInstrumentSelectorNumber: null,
            showInformationModal: false,
            isReadOnly: false,
            warningModalMessage: '',
            warningModalTitle: '',
            onWarningOkClick: () => { },
            changesName: '',
            changesComment: '',
            showChangeNameAndComment: false,
            shouldExit: false,
            symbolSelectorNumber: null
        };

        if (!this.isValidQueryParam) {
            let route = appRoutes.reporting.home;
            if (this.state.reportConfig.type === reportType.accuracy) {
                route = appRoutes.validation.home;
            }

            history.push(route);
        }

        this.onBracketSelectedListener = this.onBracketSelectedListener.bind(this);
        this.refreshCountsListener = this.refreshCountsListener.bind(this);
        this.updateLookupDataSourceId = this.updateLookupDataSourceId.bind(this);
        this.onAggregationSelected = this.onAggregationSelected.bind(this);
        this.onCaseSelected = this.onCaseSelected.bind(this);
        this.onDataSourceChange = this.onDataSourceChange.bind(this);
        this.onAggregationChange = this.onAggregationChange.bind(this);
        this.onAggregatedRecordFieldChange = this.onAggregatedRecordFieldChange.bind(this);
        this.onAggregationFilterChange = this.onAggregationFilterChange.bind(this);
        this.onLookupChange = this.onLookupChange.bind(this);
        this.onIsinSelectorChange = this.onIsinSelectorChange.bind(this);
        this.onIsinSelectorSelected = this.onIsinSelectorSelected.bind(this);
        this.onLeiSelectorSelected = this.onLeiSelectorSelected.bind(this);
        this.onLeiSelectorChange = this.onLeiSelectorChange.bind(this);
        this.onExchangeRatesSelectorChange = this.onExchangeRatesSelectorChange.bind(this);
        this.onExchangeRatesSelectorSelected = this.onExchangeRatesSelectorSelected.bind(this);
        this.onAnnaDsbUpiEnrichmentSelectorSelected = this.onAnnaDsbUpiEnrichmentSelectorSelected.bind(this);
        this.onAnnaDsbUpiSelectorSelected = this.onAnnaDsbUpiSelectorSelected.bind(this);
        this.onFCARegulatedEntitiesSelectorSelected = this.onFCARegulatedEntitiesSelectorSelected.bind(this);
        this.onVariableChange = this.onVariableChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onEndpointFilterChange = this.onEndpointFilterChange.bind(this);
        this.onValidationChange = this.onValidationChange.bind(this);
        this.onCaseChange = this.onCaseChange.bind(this);
        this.onEnrichmentChange = this.onEnrichmentChange.bind(this);
        this.onSyncedWithIdChange = this.onSyncedWithIdChange.bind(this);
        this.onMatchingKeyChange = this.onMatchingKeyChange.bind(this);
        this.onMatchingKeyEndPointChange = this.onMatchingKeyEndPointChange.bind(this);
        this.onClipboardChange = this.onClipboardChange.bind(this);
        this.save = this.save.bind(this);
        this.onRefreshDataSourcesSuccess = this.onRefreshDataSourcesSuccess.bind(this);
        this.proceedWithExit = this.proceedWithExit.bind(this);
        this.onQuickActionItemSelected = this.onQuickActionItemSelected.bind(this);
        this.onComponentContainerClick = this.onComponentContainerClick.bind(this);
        this.onCheckMinutesUntilLockWillExpire = this.onCheckMinutesUntilLockWillExpire.bind(this);
        this.onExitClick = this.onExitClick.bind(this);
        this.determinateComponent = this.determinateComponent.bind(this);
        this.processComponentWhenNotLocked = this.processComponentWhenNotLocked.bind(this);
        this.onActionItemsCountChange = this.onActionItemsCountChange.bind(this);
        this.onAnnaDsbUpiEnrichmentSelectorChange = this.onAnnaDsbUpiEnrichmentSelectorChange.bind(this);
        this.onAnnaDsbUpiSelectorChange = this.onAnnaDsbUpiSelectorChange.bind(this);
        this.onLSESelectorChange = this.onLSESelectorChange.bind(this);
        this.onSymbolSelectorChange = this.onSymbolSelectorChange.bind(this);
        this.onFCARegulatedEntitiesSelectorChange = this.onFCARegulatedEntitiesSelectorChange.bind(this);
        this.onSymbolSelectorSelected = this.onSymbolSelectorSelected.bind(this);
        this.onLSESelectorSelected = this.onLSESelectorSelected.bind(this);
        this.onFirdsFcaInstrumentSelectorChange = this.onFirdsFcaInstrumentSelectorChange.bind(this);
        this.onFirdsEsmaInstrumentSelectorChange = this.onFirdsEsmaInstrumentSelectorChange.bind(this);
        this.onFirdsFcaInstrumentSelectorSelected = this.onFirdsFcaInstrumentSelectorSelected.bind(this);
        this.onFirdsEsmaInstrumentSelectorSelected = this.onFirdsEsmaInstrumentSelectorSelected.bind(this);
        this.onDictionarySelected = this.onDictionarySelected.bind(this);
        this.onDictionaryChange = this.onDictionaryChange.bind(this);
        this.onDictionaryFieldChange = this.onDictionaryFieldChange.bind(this);
        this.onAggregationSyncedWithIdChange = this.onAggregationSyncedWithIdChange.bind(this);
        this.onFunctionSelected = this.onFunctionSelected.bind(this);
        this.onFunctionChange = this.onFunctionChange.bind(this);
        this.onFunctionParameterChange = this.onFunctionParameterChange.bind(this);
        this.selectComponent = this.selectComponent.bind(this);
        this.onTransferClick = this.onTransferClick.bind(this);
        this.onTransferConfirm = this.onTransferConfirm.bind(this);
        this.exit = this.exit.bind(this);
        this.onAddGlobalReferencedLookups = this.onAddGlobalReferencedLookups.bind(this);
        this.onGlobalModuleDataSourceSelected = this.onGlobalModuleDataSourceSelected.bind(this);
        this.onGlobalModuleDataSourceDeleted = this.onGlobalModuleDataSourceDeleted.bind(this);
        this.prepareConfigOnAddGlobalReferencedLookups = this.prepareConfigOnAddGlobalReferencedLookups.bind(this);
        this.onAddGlobalReferencedVariables = this.onAddGlobalReferencedVariables.bind(this);
        this.onOkInformationPopupClick = this.onOkInformationPopupClick.bind(this);
        this.onDragLookupBetween = this.onDragLookupBetween.bind(this);
        this.onDragFilterBetween = this.onDragFilterBetween.bind(this);
        this.onDragCaseBetween = this.onDragCaseBetween.bind(this);
        this.onDragVariableBetween = this.onDragVariableBetween.bind(this);
        this.onDragLookupBetween = this.onDragLookupBetween.bind(this);
        this.onDragEndpointFilterBetween = this.onDragEndpointFilterBetween.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
        this.onCommentChange = this.onCommentChange.bind(this);
        this.navigateToItemListener = this.navigateToItemListener.bind(this);
        this.onSymbolelectorSelected = this.onSymbolelectorSelected.bind(this);
        this.onSymbolSelectorChange = this.onSymbolSelectorChange.bind(this);
        this.onOptionalModuleSelected = this.onOptionalModuleSelected.bind(this);
        this.getOptionalModules = this.getOptionalModules.bind(this);
        this.onRemoveOptionalModule = this.onRemoveOptionalModule.bind(this);
    }

    onBracketSelectedListener() {

        let appState = store.getState();
        if (appState.action !== actions.conditionBracket.selectCorrespondingBracket) {
            return;
        }

        let conditionState = appState.selectedBracketsState;

        let config = copyObject(this.state.reportConfig);

        let bracketState = conditionState.openBracket || conditionState.closeBracket;

        let number = bracketState.location.statementNumber as number;

        switch (bracketState.location.statement) {
            case locationType.statement.lookup: setCondition(conditionState.assignment.condition as Condition, config.lookups, number); break;
            case locationType.statement.validation: setAssignment(conditionState.assignment, config.validations, number); break;
            case locationType.statement.variable: setAssignment(conditionState.assignment, config.variables, number); break;
            case locationType.statement.fcaRegulatedEntitiesSelector: setAssignment(conditionState.assignment, config.fcaRegulatedEntitiesSelectors, number); break;
            case locationType.statement.filter: setCondition(conditionState.assignment.condition as Condition, config.filters, number); break;
            case locationType.statement.underReportFilter: setCondition(conditionState.assignment.condition as Condition, config.endpointFilters.filter(x => x.type === endpointFilterType.underReport), bracketState.location.statementNumber); break;
            case locationType.statement.overReportFilter: setCondition(conditionState.assignment.condition as Condition, config.endpointFilters.filter(x => x.type === endpointFilterType.overReport), bracketState.location.statementNumber); break;
            case locationType.statement.endpointFilter: setCondition(conditionState.assignment.condition as Condition, config.endpointFilters.filter(x => x.type === endpointFilterType.regular), bracketState.location.statementNumber); break;
            case locationType.statement.firdsEsmaInstrumentSelector: setSelectorAssignmentByKey(conditionState.assignment, config.firdsEsmaInstrumentSelectors, number, bracketState.location.selectorKey || ''); break;
            case locationType.statement.firdsFcaInstrumentSelector: setSelectorAssignmentByKey(conditionState.assignment, config.firdsFcaInstrumentSelectors, number, bracketState.location.selectorKey || ''); break;
            case locationType.statement.aggregation: setCondition(conditionState.assignment.condition as Condition, config.aggregations, number); break;
            case locationType.statement.aggregatedRecordField: setAggregationFieldAssignment(conditionState.assignment, config.aggregations, number, bracketState.location.fieldId, bracketState.location.subType); break;
            case locationType.statement.dictionaryField: setDictionaryAssignment(conditionState.assignment, config.dictionaries, number, bracketState.location.fieldId); break;
            case locationType.statement.userDefinedFunction: setAssignment(conditionState.assignment, config.userDefinedFunctions, number); break;
            case locationType.statement.annaDsbUpiEnrichmentSelector: setSelectorAssignmentByKey(conditionState.assignment, config.annaDsbUpiEnrichmentSelectors, number, bracketState.location.selectorKey || ''); break;
            case locationType.statement.annaDsbUpiSelector: setAssignment(conditionState.assignment, config.annaDsbUpiSelectors, number); break;
            case locationType.statement.case: setCondition(conditionState.assignment.condition as Condition, config.cases, number); break;
            case locationType.statement.exchangeRatesSelector: setAssignment(conditionState.assignment, config.exchangeRatesSelectors, number); break;
            case locationType.statement.matchingKey: this.setMatchingKeyAssignment(config, conditionState.assignment, false); break;
            case locationType.statement.matchingKeyEndPoint: this.setMatchingKeyAssignment(config, conditionState.assignment, true); break;
            case locationType.statement.lseSelector: setAssignment(conditionState.assignment, config.lseSelectors, number); break;
            case locationType.statement.symbolSelector: setAssignment(conditionState.assignment, config.lseSelectors, number); break;
            case locationType.statement.leiSelector: setAssignment(conditionState.assignment, config.leiSelectors, number); break;
            case locationType.statement.isinSelector: setAssignment(conditionState.assignment, config.isinSelectors, number); break;
            case locationType.statement.reportField: setReporCasetFieldAssignment(conditionState.assignment, config.cases, number, bracketState.location.fieldId); break;

            default: return {} as Assignment;
        }

        this.setState({ reportConfig: config });
    }

    setMatchingKeyAssignment(config: ReportConfig, newAssignment: Assignment, isEndpoint: boolean) {
        if (isEndpoint) {
            config.matchingKeyEndPoint.assignment = newAssignment;
        }
        else {
            config.matchingKey.assignment = newAssignment;
        }
    }

    onGlobalModuleDataSourceDeleted(id: number) {
        this.pageContext.collections.globalModuleDataSources = this.pageContext.collections.globalModuleDataSources.filter(x => x.id !== id);
    }

    onGlobalModuleDataSourceSelected(id: number) {
        let ds = this.pageContext.collections.globalModuleConfig.refDataSources.find(x => x.id === id) as RefDataSource;

        let newDataSource = {
            id,
            name: ds.name,
            dataSourceKind: ds.dataSouceKind

        } as IngestionConfig;

        this.pageContext.collections.globalModuleDataSources.push(newDataSource);

        this.pageContext.collections.dataSources.push(newDataSource);

        if (!this.state.reportConfig.refDataSources.map(x => x.id).includes(id)) {

            let config = copyObject(this.state.reportConfig);

            config.refDataSources.push({ id: id, runStatus: 0, dataSouceKind: ds.dataSouceKind, name: ds.name } as RefDataSource);

            this.setState({ reportConfig: config });
        }
        else {
            this.forceUpdate();
        }
    }

    getState(config: ReportConfig): State {

        let result = copyObject(this.state) as State;

        result.isWaiting = false;
        result.reportConfig = config;

        if (config.type !== reportType.accuracy && config.type !== reportType.globalModule) {

            result.caseNumber = config.cases[0].number;
        }

        if (config.dictionaries?.length > 0) {

            result.dictionaryNumber = config.dictionaries[0].number;
        }

        if (config.userDefinedFunctions?.length > 0) {

            result.functionNumber = config.userDefinedFunctions[0].number;
            result.isReadOnly = config.userDefinedFunctions[0].mode === Mode.Global;
        }

        if (config.aggregations?.length > 0) {

            result.aggregationNumber = config.aggregations[0].number;
        }

        if (config.isinSelectors?.length > 0) {

            result.isinSelectorNumber = config.isinSelectors[0].number;
        }

        if (config.leiSelectors?.length > 0) {

            result.leiSelectorNumber = config.leiSelectors[0].number;
        }

        if (config.exchangeRatesSelectors?.length > 0) {

            result.exchangeRatesSelectorNumber = config.exchangeRatesSelectors[0].number;
        }

        if (config.annaDsbUpiEnrichmentSelectors?.length > 0) {

            result.annaDsbUpiEnrichmentNumber = config.annaDsbUpiEnrichmentSelectors[0].number;
        }

        if (config.annaDsbUpiSelectors?.length > 0) {

            result.annaDsbUpiNumber = config.annaDsbUpiSelectors[0].number;
        }

        if (config.lseSelectors?.length > 0) {

            result.lseNumber = config.lseSelectors[0].number;
        }

        if (config.symbolSelectors?.length > 0) {

            result.symbolSelectorNumber = config.symbolSelectors[0].number;
        }

        if (config.firdsFcaInstrumentSelectors?.length > 0) {

            result.firdsFcaInstrumentSelectorNumber = config.firdsFcaInstrumentSelectors[0].number;
        }

        if (config.firdsEsmaInstrumentSelectors?.length > 0) {

            result.firdsEsmaInstrumentSelectorNumber = config.firdsEsmaInstrumentSelectors[0].number;
        }

        if (config.fcaRegulatedEntitiesSelectors?.length > 0) {

            result.fcaRegulatedEntitiesNumber = config.fcaRegulatedEntitiesSelectors[0].number;
        }

        return result;
    }

    isConfigWithReadOnlyAccess(config: ReportConfig): boolean {

        if (config.type === reportType.accuracy) {
            return this.query['released'] === 'true';
        }

        let identity = identityStorage.get();

        return !writeUserRoles.includes(identity.userRole) || this.query['released'] === 'true';
    }

    navigateToItemListener(): void {

        let appState = store.getState();

        if (appState.action === actions.navigation.navigateToItem) {

            let state = appState.navigateToItem;

            this.navigatoToItem(state);

        }

        if (appState.action === actions.navigation.navigatoToComponentNumber) {

            let state = appState.navigatoToComponentNumber;

            this.navigateToComponentNumber(state);
        }
    }

    navigateToComponentNumber(state: NavigateToComponentNumber) {

        const navigate = () => {
            reportConfigNavigation.navigateToItemInSection(state.htmlId, state.sectionId);
        }

        switch (state.componentType) {
            case ComponentType.IsinSelector: this.onIsinSelectorSelected(state.number, navigate); break;
            case ComponentType.LeiSelector: this.onLeiSelectorSelected(state.number, navigate); break;
            case ComponentType.SymbolSelector: this.onSymbolSelectorSelected(state.number, navigate); break;
            case ComponentType.LseSelector: this.onLSESelectorSelected(state.number, navigate); break;
            case ComponentType.FCARegulatedEntitiesSelector: this.onFCARegulatedEntitiesSelectorSelected(state.number, navigate); break;
            case ComponentType.ExchangeRatesSelector: this.onExchangeRatesSelectorSelected(state.number, navigate); break;
            case ComponentType.FirdsEsmaInstrumentSelectors: this.onFirdsEsmaInstrumentSelectorSelected(state.number, navigate); break;
            case ComponentType.AnnaDsbUpiEnrichmentSelector: this.onAnnaDsbUpiEnrichmentSelectorSelected(state.number, navigate); break;
            case ComponentType.AnnaDsbUpiSelector: this.onAnnaDsbUpiSelectorSelected(state.number, navigate); break;
            case ComponentType.FirdsFcaInstrumentSelectors: this.onFirdsFcaInstrumentSelectorSelected(state.number, navigate); break;
            case ComponentType.UserDefinedFunction: this.onFunctionSelected(state.number, navigate); break;
            case ComponentType.Dictionary: this.onDictionarySelected(state.number, navigate); break;
            case ComponentType.Aggregation: this.onAggregationSelected(state.number, navigate); break;
            case ComponentType.Case: this.onCaseSelected(state.number, navigate); break;

            default: break;
        }
    }

    navigatoToItem(state: NavigateToItem) {

        if (state.location.statement === locationType.statement.case || state.location.statement === locationType.statement.reportField) {

            let aggregationNumber = this.state.reportConfig.cases.find(x => x.number === state.location.statementNumber)?.aggregationNumber;

            if (aggregationNumber) {
                this.setState({ aggregationNumber }, () =>
                    reportConfigNavigation.navigateToItem(state.details.definitionHtmlId as string)
                );
            }
            else {
                reportConfigNavigation.navigateToItem(state.details.definitionHtmlId as string);
            }
        }
        else if (state.details.operandType === operandType.variable) {
            store.dispatch({
                type: actions.navigation.expand, payload: {
                    expandHtmlId: htmlIds.variables
                } as ReportConfigNavigationPayload
            });

            reportConfigNavigation.navigateToItem(state.details.definitionHtmlId as string);
        }
        else if (state.details.operandType === operandType.lookupField) {
            store.dispatch({
                type: actions.navigation.expand, payload: {
                    expandHtmlId: htmlIds.lookups
                } as ReportConfigNavigationPayload
            });

            reportConfigNavigation.navigateToItem(state.details.definitionHtmlId as string);
        }
        else {
            reportConfigNavigation.navigateToItem(state.details.definitionHtmlId as string);
        }
    }

    async componentDidMount(): Promise<void> {

        if (!this.isValidQueryParam) {
            return;
        }

        this.unsubscribe = store.subscribe(this.refreshCountsListener);
        this.unsubscribeSelectComponent = store.subscribe(this.selectComponent);
        this.unsubscribeTransferConfirm = store.subscribe(this.onTransferConfirm);
        this.unsubscribeBracketSelect = store.subscribe(this.onBracketSelectedListener);
        this.unsubscribeAggregationSelect = store.subscribe(this.navigateToItemListener);

        this.setState({ isWaiting: true });

        const onGetCollectionsSuccess = async (config: ReportConfig, dataSourceOptions: IngestionConfigOption[], dataSources: IngestionConfig[], reportFieldDefinitions: ReportFieldDefinition[], customDataSourceFields: CustomDataSourceFields): Promise<void> => {

            store.dispatch({ type: actions.optionalModules.set, payload: config.optionalModules || [] });

            reportConfigStorage.set(config);

            editReportConfigHelper.prepare(config, dataSources);

            if (typeHelper.isString(config.subRegime)) {

                for (var i = 0; i < reportFieldDefinitions.length; i++) {

                    let definition = reportFieldDefinitions[i];

                    definition.isHidden = !definition.subRegimes.includes(config.subRegime as string);
                }
            }

            if (config.type !== reportType.globalModule && config.type !== reportType.accuracy) {
                await addGlobalModuleConfig(this.pageContext, config.createdById);

                if (this.pageContext.collections.globalModuleConfig) {
                    addGlobalModuleDataSources(this.pageContext.collections.globalModuleConfig, this.pageContext);
                }
            }

            seedReportDataSourceOptions(dataSourceOptions, this.pageContext);
            seedReportDataSources(dataSources, this.pageContext);
            seedReportFields(reportFieldDefinitions, this.pageContext);
            seedCustomDataSourceFields(customDataSourceFields, this.pageContext);

            let selectorsAppState: SelectorsState = {
                isinSelectors: config.isinSelectors,
                leiSelectors: config.leiSelectors,
                exchangeRatesSelectors: config.exchangeRatesSelectors,
                annaDsbUpiEnrichmentSelectors: config.annaDsbUpiEnrichmentSelectors,
                annaDsbUpiSelectors: config.annaDsbUpiSelectors,
                lSESelectors: config.lseSelectors,
                symbolSelectors: config.symbolSelectors,
                firdsFcaInstrumentSelectors: config.firdsFcaInstrumentSelectors,
                firdsEsmaInstrumentSelectors: config.firdsEsmaInstrumentSelectors,
                fcaRegulatedEntitiesSelectors: config.fcaRegulatedEntitiesSelectors,
                selectorIndex: 0
            };

            selectorsStore.dispatch({ type: actions.selectors.save, payload: selectorsAppState });

            let state = this.getState(config);

            state.isReadOnly = this.state.isReadOnly;

            if (!state.isReadOnly) {
                let isReadOnly = await isPendingApproval(this.id);

                if (isReadOnly) {
                    state.showInformationModal = true;
                    state.warningModalMessage = configIsWaitingApprovalMessage;
                    state.warningModalTitle = configIsWaitingApprovalTitle;
                }
                else {
                    isReadOnly = this.isConfigWithReadOnlyAccess(config);
                }

                state.isReadOnly = isReadOnly;
            }

            if (this.mainComponentNumber) {

                this.setSelectedMainComponentNumber(state);

                store.dispatch({
                    type: actions.navigation.expand, payload: {
                        expandHtmlId: this.section,
                        scrollToHtmlId: this.htmlid
                    } as ReportConfigNavigationPayload
                });
            }

            this.setState(state, () => {
                getCounts(this.state.reportConfig.regime, this.id).then(response => this.setState({ counts: response.data }));

                if (this.section && this.htmlid) {

                    reportConfigNavigation.navigateToItemInSection(this.htmlid, this.section);
                }
            });
        };

        let isReadOnly = this.state.isReadOnly;

        if (!isReadOnly) {
            let isReadOnly = await isPendingApproval(this.id);

            if (!isReadOnly) {
                isReadOnly = this.query['released'] === 'true';
            }
        }
        const reportConfigTypes = ['Accuracy', 'AccuracyCore'];

        var usedByAnotherUserMessage = await lockManager.isReportConfigUsedByOtherUser(this.id)
        if (usedByAnotherUserMessage) {
            messageHelper.showMesage(usedByAnotherUserMessage, false);
        }

        var response = await getConfigById(this.id, isReadOnly);

        if (reportConfigTypes.includes(response.data.type)) {
            const intervalId = this.setReportConfigInterval();
            this.setState({ reportConfigIntervalId: intervalId });
        }
        else {
            await this.setReportIsLocked();
        }

        if (response.data.type !== reportType.globalModule) {
            Promise.all([response.data, getDataSourceOptions(response.data.type, this.id), getReportDataSources(response.data), getReportFields(response.data), getCustomDataSourceFields()])
                .then(responses => onGetCollectionsSuccess(responses[0], responses[1].data, responses[2].data, responses[3].data, responses[4].data));
        }
        else {
            this.proceedWithGlobalModuleConfig(response.data);
        }
    }

    async lock(): Promise<void> {

        let response = await lockManager.lock(this.id)

        let message = getLockedMessage(response);

        let canEdit = allowEdit(response);

        if (this.state.isReadOnly !== canEdit || this.state.lockMessage !== message) {
            this.setState({ isReadOnly: !canEdit, lockMessage: message });
        }
    };

    setSelectedMainComponentNumber(state: State) {
        switch (this.section) {
            case htmlIds.caseFields: state.caseNumber = parseInt(this.mainComponentNumber); break;
            case htmlIds.aggregationFields: state.aggregationNumber = parseInt(this.mainComponentNumber); break;
            case htmlIds.dictionaryFields: state.dictionaryNumber = parseInt(this.mainComponentNumber); break;
            case htmlIds.userDefinedFunctions: state.functionNumber = parseInt(this.mainComponentNumber); break;
            default: break;
        }
    }

    proceedWithGlobalModuleConfig(config: ReportConfig) {

        getDataSourceOptions(config.type, this.id)
            .then(response => seedReportDataSourceOptions(response.data, this.pageContext))
            .then(() => getReportDataSources(config))
            .then(response => {
                reportConfigStorage.set(config);
                editReportConfigHelper.prepare(config, response.data);
                seedReportDataSources(response.data, this.pageContext);
            })
            .then(() => isPendingApproval(this.id))
            .then(isPendingApproval => this.setStateValues(isPendingApproval, config))
    }

    async setStateValues(isReadOnly: boolean, config: ReportConfig): Promise<void> {

        let state = this.getState(config);

        if (isReadOnly) {
            state.showInformationModal = true;
            state.warningModalMessage = configIsWaitingApprovalMessage;
            state.warningModalTitle = configIsWaitingApprovalTitle;
        }
        else {
            isReadOnly = await this.isConfigWithReadOnlyAccess(config);
        }

        state.isReadOnly = isReadOnly;

        this.setState(state, () => {
            if (this.section && this.htmlid) {
                reportConfigNavigation.navigateToItemInSection(this.htmlid, this.section);
            }
        });
    }

    setReportConfigInterval() {
        const intervalId = setInterval(async () => {
            clearInterval(this.state.reportConfigIntervalId);
        }, this.oneMinutesInMileseconds);

        return intervalId;
    }

    async onCheckMinutesUntilLockWillExpire(componentId: number, componentType: ComponentType) {

        if (this.state.editedComponents.length) {
            const editedComponent = this.state.editedComponents.find(x => x.componentId === componentId && x.componentType === componentType);
            if (editedComponent) {
                let reportConfigCopy = Object.assign({}, this.state.reportConfig);
                let component;
                let name;
                switch (editedComponent.componentType) {
                    case ComponentType.Variable: component = reportConfigCopy.variables.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.Lookup: component = reportConfigCopy.lookups.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.LeiSelector: component = reportConfigCopy.leiSelectors.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.ExchangeRatesSelector: component = reportConfigCopy.exchangeRatesSelectors.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.AnnaDsbUpiEnrichmentSelector: component = reportConfigCopy.annaDsbUpiEnrichmentSelectors.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.AnnaDsbUpiSelector: component = reportConfigCopy.annaDsbUpiSelectors.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.LseSelector: component = reportConfigCopy.lseSelectors.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.SymbolSelector: component = reportConfigCopy.symbolSelectors.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.FirdsFcaInstrumentSelectors: component = reportConfigCopy.firdsFcaInstrumentSelectors.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.FirdsEsmaInstrumentSelectors: component = reportConfigCopy.firdsEsmaInstrumentSelectors.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.IsinSelector: component = reportConfigCopy.isinSelectors.find(v => v.id === editedComponent?.componentId); name = component?.name; break;
                    case ComponentType.AccuracyValidation: component = reportConfigCopy.validations.find(v => v.id === editedComponent?.componentId); name = component?.identifier; break;
                    default: break;
                }

                const willExpireIn = await lockManager.getMinutesWhenLockWillExpire(editedComponent);

                if (willExpireIn > 5 && willExpireIn < 6) {

                    let message = `Please save the config.The automatic lock on ${editedComponent.componentType}, ID: ${editedComponent.componentId}, Name: ${name || ''} will be released in 5 minutes.`;

                    messageHelper.showMesage(message, true);
                }
                else if (willExpireIn === 0) {

                    clearInterval(editedComponent.intervalId);
                    if (component) {
                        component.isLocked = false;
                        component.isUsedByCurrentUser = false;
                        component.isReadOnly = false;
                    }

                    let editedComponents = this.state.editedComponents.slice();
                    editedComponents = editedComponents.filter(c => c.intervalId !== editedComponent.intervalId);

                    let message = `${editedComponent.componentType}, ID: ${editedComponent.componentId}, Name: ${name || ''} has been unlocked. Save the config immediately to ensure that your changes are not lost or overwritten by another user.`;
                    messageHelper.showMesage(message, true);

                    this.setState({ reportConfig: reportConfigCopy, editedComponents });
                }
            }
        }
    }

    componentWillUnmount(): void {

        if (this.unsubscribe) {
            (this.unsubscribe as Unsubscribe)();
            (this.unsubscribeSelectComponent as Unsubscribe)();
            (this.unsubscribeTransferConfirm as Unsubscribe)();
            (this.unsubscribeBracketSelect as Unsubscribe)();
            (this.unsubscribeAggregationSelect as Unsubscribe)();

            this.state.editedComponents.forEach((component) => {
                clearInterval(component.intervalId);
            })
            clearInterval(this.state.reportConfigIntervalId);

            clearInterval(this.lockIntervalId);
        }
    }

    selectComponent(): void {
        let storeState = store.getState();

        let proceed = storeState.action === actions.component.selected;

        if (!proceed) {
            return;
        }

        switch (storeState.selectedComponentState.componentType) {
            case ComponentType.AnnaDsbUpiEnrichmentSelector: this.onAnnaDsbUpiEnrichmentSelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.AnnaDsbUpiSelector: this.onAnnaDsbUpiSelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.IsinSelector: this.onIsinSelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.LeiSelector: this.onLeiSelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.LseSelector: this.onLSESelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.SymbolSelector: this.onSymbolelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.FirdsEsmaInstrumentSelectors: this.onFirdsEsmaInstrumentSelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.FirdsFcaInstrumentSelectors: this.onFirdsFcaInstrumentSelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.ExchangeRatesSelector: this.onExchangeRatesSelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.FCARegulatedEntitiesSelector: this.onFCARegulatedEntitiesSelectorSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.CaseField: this.onCaseSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.AggregationField: this.onAggregationSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.DictionaryField: this.onDictionarySelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.Aggregation: this.onAggregationSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.Dictionary: this.onDictionarySelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;
            case ComponentType.Case: this.onCaseSelected(storeState.selectedComponentState.number, storeState.selectedComponentState.callback); break;

            default: break;
        }
    }

    refreshCountsListener(): void {
        let state = store.getState();

        let proceed =
            state.action === actions.complianceCommentModal.saveSuccess ||
            state.action === actions.complianceCommentModal.deleteCommentSuccess ||
            state.action === actions.actionItemModal.saveSuccess;

        if (!proceed) {
            return;
        }

        getCounts(this.state.reportConfig.regime, this.id).then(response => this.setState({ counts: response.data }));
    }

    updateLookupDataSourceId(lookup: Lookup): void {

        lookupDataSourceHelper.updateLookupDataSourceId(lookup, this.pageContext.collections.dataSources.filter(x => x.id !== lookup.dataSource1Id));
    }

    onAggregationSelected(number: number, callback?: () => void): void {

        this.setState({ aggregationNumber: number }, () => callback ? callback() : undefined);
    }

    onSymbolelectorSelected(number: number, callback?: () => void): void {

        this.setState({ symbolSelectorNumber: number }, () => callback ? callback() : undefined);
    }

    onIsinSelectorSelected(number: number, callback?: () => void): void {

        this.setState({ isinSelectorNumber: number }, () => callback ? callback() : undefined);
    }

    onLeiSelectorSelected(number: number, callback?: () => void): void {

        this.setState({ leiSelectorNumber: number }, () => callback ? callback() : undefined);
    }

    onExchangeRatesSelectorSelected(number: number, callback?: () => void): void {

        this.setState({ exchangeRatesSelectorNumber: number }, () => callback ? callback() : undefined);
    }

    onAnnaDsbUpiEnrichmentSelectorSelected(number: number, callback?: () => void): void {

        this.setState({ annaDsbUpiEnrichmentNumber: number }, () => callback ? callback() : undefined);
    }

    onLSESelectorSelected(number: number, callback?: () => void): void {

        this.setState({ lseNumber: number }, () => callback ? callback() : undefined);
    }

    onSymbolSelectorSelected(number: number, callback?: () => void): void {

        this.setState({ symbolSelectorNumber: number }, () => callback ? callback() : undefined);
    }

    onFCARegulatedEntitiesSelectorSelected(number: number, callback?: () => void): void {

        this.setState({ fcaRegulatedEntitiesNumber: number }, () => callback ? callback() : undefined);
    }

    onFirdsFcaInstrumentSelectorSelected(number: number, callback?: () => void): void {

        this.setState({ firdsFcaInstrumentSelectorNumber: number }, () => callback ? callback() : undefined);
    }

    onFirdsEsmaInstrumentSelectorSelected(number: number, callback?: () => void): void {

        this.setState({ firdsEsmaInstrumentSelectorNumber: number }, () => callback ? callback() : undefined);
    }

    onAnnaDsbUpiSelectorSelected(number: number, callback?: () => void): void {

        this.setState({ annaDsbUpiNumber: number }, () => callback ? callback() : undefined);
    }

    onCaseSelected(number: number, callback?: () => void): void {

        this.setState({ caseNumber: number }, () => callback ? callback() : undefined);
    }

    onDictionarySelected(number: number, callback?: () => void): void {

        this.setState({ dictionaryNumber: number }, () => callback ? callback() : undefined);
    }

    onFunctionSelected(number: number, callback?: () => void): void {

        this.setState({ functionNumber: number }, () => callback ? callback() : undefined);
    }

    onDataSourceChange(changes: ReportConfig): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let isDataSourceChange =
            typeHelper.isNumber(changes.rawDataSourceId) ||
            (typeHelper.isArray(changes.refDataSources) && changes.refDataSources.length !== this.state.reportConfig.refDataSources.length);

        let reportConfig = Object.assign({}, copyObject(this.state.reportConfig), changes);

        if (changes.type === reportType.directReporting) {

            let skipModules = [OptionalModule.MatchingKeys.toString(),
            OptionalModule.EndPointFilteringLogic.toString(),
            OptionalModule.ExpectedOverReportLogic.toString(),
            OptionalModule.ExpectedUnderReportLogic.toString()];

            reportConfig.optionalModules = reportConfig.optionalModules.filter(x => !skipModules.includes(x));
        }
        else {
            let state = store.getState();

            reportConfig.optionalModules = state.optionalModules;

            if (reportConfig.matchingKey.assignment || reportConfig.matchingKey.operands?.length > 1 ||
                reportConfig.matchingKeyEndPoint.assignment || reportConfig.matchingKeyEndPoint.operands?.length > 1) {
                reportConfig.optionalModules.push(OptionalModule.MatchingKeys);
            }
        }

        this.setState({ reportConfig: reportConfig }, () => {

            if (!isDataSourceChange) {
                return;
            }

            getReportDataSources(this.state.reportConfig).then(this.onRefreshDataSourcesSuccess);
        });
    }

    onAggregationChange(aggregationNumber: number, aggregations: Aggregation[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        let isAggregationRemoved = aggregations.length < this.state.reportConfig.aggregations.length;
        if (isAggregationRemoved) {

            let newNumbers = new Map<number, number>();

            aggregations.forEach((aggr, index) => {
                newNumbers.set(aggr.number, index + 1);
                aggr.number = index + 1;
            });

            let cases = copyArray(this.state.reportConfig.cases);

            for (let i = 0; i < cases.length; i++) {

                if (cases[i].aggregationNumber) {
                    cases[i].aggregationNumber = newNumbers.get(cases[i].aggregationNumber as number) as number;

                    cases[i].fields.forEach((f) => {

                        operandHelper.proceedWhitAssignment(f.assignment, (operand: Operand) => {
                            if (operand.aggregationNumber === aggregationNumber) {
                                operand.aggregationNumber = newNumbers.get(aggregationNumber) as number;
                            }
                        });
                    });
                }
            }

            changes.reportConfig = Object.assign({}, this.state.reportConfig, { cases, aggregations } as ReportConfig);

            if (aggregations.length === 0) {

                changes.aggregationNumber = null;
            }
            else if (!aggregations.some(a => a.number === this.state.aggregationNumber)) {

                changes.aggregationNumber = aggregations[0].number;
            }
        }
        else {
            changes.aggregationNumber = aggregationNumber || 1;

            changes.reportConfig = Object.assign({}, this.state.reportConfig, { aggregations } as ReportConfig);
        }

        this.setState(changes);
    }

    onQuickActionFieldChange(value: string): void {

        let number = this.pageContext.collections.reportFields.find(x => x.id === parseInt(value))?.number as number;

        let fieldId = reportConfigNavigation.buildReportFieldId(number);

        reportConfigNavigation.navigateToItem(fieldId);
    }

    onAggregatedRecordFieldChange(number: number, fields: DataSourceField[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let target = this.state.reportConfig.aggregations.find(x => x.number === number) as Aggregation;

        target.fields = fields;

        aggregationHelper.handleAggregationChanges(this.state.reportConfig.aggregations);

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { aggregations: this.state.reportConfig.aggregations } as ReportConfig)
        });
    }

    onAggregationFilterChange(filters: AggregationFilter[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        this.state.reportConfig.aggregations.forEach((aggregation) => {
            aggregation.filters = filters.filter(x => x.aggregationNumber === aggregation.number);
        });

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { aggregations: this.state.reportConfig.aggregations } as ReportConfig)
        });
    }

    onLookupChange(lookups: Lookup[], location?: ReportLogicLocation, actionType?: ActionType): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let currentLookupsNames = lookups.map(x => x.name);

        let removedLookup = this.state.reportConfig.lookups.find(x => !currentLookupsNames.includes(x.name)) as Lookup;

        if (removedLookup && removedLookup.mode === Mode.Global) {

            let removedDatasource1 = true;
            let removedDatasource2 = true;

            lookups.filter(x => x.mode === Mode.Global).forEach((lookup) => {

                let globalModuleDataSourceIds = getGlobalModuleDetaSourceValues(this.pageContext.collections as ReportCollections, this.state.reportConfig);

                removedDatasource1 = !globalModuleDataSourceIds.includes(lookup.dataSource1Id?.toString() as string) &&
                    isDataSourceReferencedInCurrentConfig(lookup.dataSource1Id as number, this.state.reportConfig) === false;

                removedDatasource2 = !globalModuleDataSourceIds.includes(lookup.dataSource2Id?.toString() as string) &&
                    isDataSourceReferencedInCurrentConfig(lookup.dataSource2Id as number, this.state.reportConfig) === false;

                if (removedLookup.dataSource1Id === lookup.dataSource1Id || removedLookup.dataSource2Id === lookup.dataSource1Id) {
                    removedDatasource1 = false;
                }
                if (removedLookup.dataSource2Id === lookup.dataSource1Id || removedLookup.dataSource2Id === lookup.dataSource1Id) {
                    removedDatasource2 = false;
                }
            });

            if (removedDatasource1) {
                this.pageContext.collections.globalModuleDataSources = this.pageContext.collections.globalModuleDataSources.filter(x => x.id !== removedLookup.dataSource1Id);
            }
            if (removedDatasource2) {
                this.pageContext.collections.globalModuleDataSources = this.pageContext.collections.globalModuleDataSources.filter(x => x.id !== removedLookup.dataSource2Id);
            }
        }

        let reportCfg = copyObject(this.state.reportConfig);

        let config = Object.assign({}, reportCfg, { lookups } as ReportConfig);

        if (actionType === ActionType.Add) {
            reorderHelper.changeReferences(config,
                lookups, (operand: Operand, oldAndNewNumbers: Map<number, number>) => {
                    if (operand.lookupNumber && oldAndNewNumbers.has(operand.lookupNumber)) {
                        operand.lookupNumber = oldAndNewNumbers.get(operand.lookupNumber) as number;
                    }
                }
            );
        }

        if (lookups.filter(x => x.mode === Mode.Global).length) {
            config.globalModuleConfigId = this.pageContext.collections.globalModuleConfig.id;
        }

        let lookup =lookups.find(x=>x.number === location?.statementNumber) as Lookup;

        if(lookup?.method === Method.Indexed) {
          lookup.operands= conditionHelper.getAllOperands(lookup.condition);
        }

        this.setState({ reportConfig: config }, () => {
            store.dispatch({ type: actions.component.change, payload: { actionType, location } as ComponentChangeState });
        });
    }

    onIsinSelectorChange(isinSelectors: Selector[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { isinSelectors: isinSelectors } as ReportConfig);

        if (isinSelectors.length === 0) {

            changes.isinSelectorNumber = null;
        }
        else if (!isinSelectors.some(a => a.number === this.state.isinSelectorNumber)) {

            changes.isinSelectorNumber = isinSelectors[0].number;
        }

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.isinChanged, payload: isinSelectors });
    }

    onLeiSelectorChange(leiSelectors: Selector[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { leiSelectors: leiSelectors } as ReportConfig);

        if (leiSelectors.length === 0) {

            changes.leiSelectorNumber = null;
        }
        else if (!leiSelectors.some(a => a.number === this.state.leiSelectorNumber)) {

            changes.leiSelectorNumber = leiSelectors[0].number;
        }

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.leiChanged, payload: leiSelectors });
    }

    onExchangeRatesSelectorChange(exchangeRatesSelectors: Selector[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { exchangeRatesSelectors: exchangeRatesSelectors } as ReportConfig);

        if (exchangeRatesSelectors.length === 0) {

            changes.exchangeRatesSelectorNumber = null;
        }
        else if (!exchangeRatesSelectors.some(a => a.number === this.state.exchangeRatesSelectorNumber)) {

            changes.exchangeRatesSelectorNumber = exchangeRatesSelectors[0].number;
        }

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.exchangeRatesChanged, payload: exchangeRatesSelectors });
    }

    onAnnaDsbUpiSelectorChange(selectors: Selector[]): void {
        var state = selectorsStore.getState();

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        if (selectors.length === 0) {

            changes.annaDsbUpiNumber = null;
        }
        else if (!selectors.some(a => a.number === this.state.annaDsbUpiNumber)) {

            changes.annaDsbUpiNumber = selectors[0].number;
        }

        let newSelectors = selectors;
        newSelectors.forEach((sel) => {
            if (state.selectors.selectorIndex && sel.keys && sel.number === this.state.annaDsbUpiNumber) {
                sel.keys[state.selectors.selectorIndex].assignment = Object.assign({}, sel.assignment);
            }
        })

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { annaDsbUpiSelectors: newSelectors } as ReportConfig);

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.annaDsbUpiChanged, payload: selectors });
    }

    onFirdsFcaInstrumentSelectorChange(selectors: Selector[]): void {
        var state = selectorsStore.getState();

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;


        if (selectors.length === 0) {

            changes.firdsFcaInstrumentSelectorNumber = null;
        }
        else if (!selectors.some(a => a.number === this.state.firdsFcaInstrumentSelectorNumber)) {

            changes.firdsFcaInstrumentSelectorNumber = selectors[0].number;
        }

        let newSelectors = selectors as FirdsInstrumentSelector[];
        newSelectors.forEach((sel) => {
            if (state.selectors.selectorIndex && sel.keys && sel.number === this.state.firdsFcaInstrumentSelectorNumber) {
                sel.keys[state.selectors.selectorIndex].assignment = Object.assign({}, sel.assignment);
            }
        })

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { firdsFcaInstrumentSelectors: newSelectors } as ReportConfig);

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.firdsFcaInstrumentChange, payload: selectors });
    }

    onFirdsEsmaInstrumentSelectorChange(selectors: Selector[]): void {
        var state = selectorsStore.getState();

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;


        if (selectors.length === 0) {

            changes.firdsEsmaInstrumentSelectorNumber = null;
        }
        else if (!selectors.some(a => a.number === this.state.firdsEsmaInstrumentSelectorNumber)) {

            changes.firdsEsmaInstrumentSelectorNumber = selectors[0].number;
        }

        let newSelectors = selectors as FirdsInstrumentSelector[];
        newSelectors.forEach((sel) => {
            if (state.selectors.selectorIndex && sel.keys && sel.number === this.state.firdsEsmaInstrumentSelectorNumber) {
                sel.keys[state.selectors.selectorIndex].assignment = Object.assign({}, sel.assignment);
            }
        })

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { firdsEsmaInstrumentSelectors: newSelectors } as ReportConfig);

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.firdsEsmaInstrumentChange, payload: selectors });
    }


    onAnnaDsbUpiEnrichmentSelectorChange(selectors: Selector[]): void {
        var state = selectorsStore.getState();

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;


        if (selectors.length === 0) {

            changes.annaDsbUpiEnrichmentNumber = null;
        }
        else if (!selectors.some(a => a.number === this.state.annaDsbUpiEnrichmentNumber)) {

            changes.annaDsbUpiEnrichmentNumber = selectors[0].number;
        }

        let newSelectors = selectors as AnnaDsbSelector[];
        newSelectors.forEach((sel) => {
            if (state.selectors.selectorIndex && sel.keys && sel.number === this.state.annaDsbUpiEnrichmentNumber) {
                sel.keys[state.selectors.selectorIndex].assignment = Object.assign({}, sel.assignment);
            }
        })

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { annaDsbUpiEnrichmentSelectors: newSelectors } as ReportConfig);

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.annaDsbUpiEnrichmentChanged, payload: selectors });
    }

    onSymbolSelectorChange(selectors: Selector[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { symbolSelectors: selectors } as ReportConfig);

        if (selectors.length === 0) {

            changes.symbolSelectorNumber = null;
        }
        else if (!selectors.some(a => a.number === this.state.symbolSelectorNumber)) {

            changes.symbolSelectorNumber = selectors[0].number;
        }

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.symbolChanged, payload: selectors });
    }

    onLSESelectorChange(selectors: Selector[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { lseSelectors: selectors } as ReportConfig);

        if (selectors.length === 0) {

            changes.lseNumber = null;
        }
        else if (!selectors.some(a => a.number === this.state.lseNumber)) {

            changes.lseNumber = selectors[0].number;
        }

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.lseChanged, payload: selectors });
    }

    onFCARegulatedEntitiesSelectorChange(selectors: Selector[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { fcaRegulatedEntitiesSelectors: selectors } as ReportConfig);

        if (selectors.length === 0) {

            changes.fcaRegulatedEntitiesNumber = null;
        }
        else if (!selectors.some(a => a.number === this.state.fcaRegulatedEntitiesNumber)) {

            changes.fcaRegulatedEntitiesNumber = selectors[0].number;
        }

        this.setState(changes);

        selectorsStore.dispatch({ type: actions.selectors.fcaRegulatedEntitiesChange, payload: selectors });
    }

    onVariableChange(variables: ReportVariable[], location?: ReportLogicLocation, actionType?: ActionType): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        this.setState({
            reportConfig: Object.assign({}, copyObject(this.state.reportConfig), { variables: variables } as ReportConfig), clipboard: null
        }, () => {
            store.dispatch({ type: actions.component.change, payload: { actionType, location } as ComponentChangeState });
        });
    }

    onFilterChange(filters: ReportFilter[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { filters: filters } as ReportConfig),
            clipboard: null
        });
    }

    onEndpointFilterChange(filters: EndpointFilter[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { endpointFilters: filters } as ReportConfig),
            clipboard: null
        });
    }

    onValidationChange(validations: AccuracyValidation[], location?: ReportLogicLocation, actionType?: ActionType): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { validations: validations } as ReportConfig),
            clipboard: null
        }, () => {
            store.dispatch({ type: actions.component.change, payload: { actionType, location } as ComponentChangeState });
        });
    }

    onCaseChange(cases: ReportCase[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        enrichmentHelper.handleCaseChanges(cases, this.pageContext.collections.reportFields.map(x => x.id));

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { cases: cases } as ReportConfig);
        changes.clipboard = null

        if (isResetRequired(this.state.caseNumber, cases)) {
            changes.caseNumber = cases[0].number;
        }

        this.setState(changes);
    }

    onEnrichmentChange(number: number, fields: ReportCaseField[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let cases = copyArray(this.state.reportConfig.cases);

        let target = cases.find(x => x.number === number) as ReportCase;

        target.fields = fields;

        enrichmentHelper.handleEnrichmentChanges(cases);

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { cases } as ReportConfig)
        });
    }

    onSyncedWithIdChange(number: number, syncedWithId: number | null): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let target = this.state.reportConfig.cases.find(x => x.number === number) as ReportCase;

        target.syncedWithId = syncedWithId;

        enrichmentHelper.handleEnrichmentChanges(this.state.reportConfig.cases);

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { cases: this.state.reportConfig.cases } as ReportConfig)
        });
    }


    onAggregationSyncedWithIdChange(number: number, syncedWithId: number | null): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let target = this.state.reportConfig.aggregations.find(x => x.number === number) as Aggregation;

        target.syncedWithId = syncedWithId;

        aggregationHelper.handleAggregationChanges(this.state.reportConfig.aggregations);

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { aggregations: this.state.reportConfig.aggregations } as ReportConfig)
        });
    }

    onMatchingKeyChange(matchingKey: MatchingKey): void {

        matchingKey.operands = [];

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { matchingKey: matchingKey } as ReportConfig)
        });
    }

    onMatchingKeyEndPointChange(matchingKeyEndPoint: MatchingKey): void {

        matchingKeyEndPoint.operands = [];

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        this.setState({
            reportConfig: Object.assign({}, this.state.reportConfig, { matchingKeyEndPoint: matchingKeyEndPoint } as ReportConfig)
        });
    }

    onDictionaryChange(dictionaries: Dictionary[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { dictionaries: dictionaries } as ReportConfig);

        if (dictionaries.length === 0) {

            changes.dictionaryNumber = null;
        }
        else if (!dictionaries.some(a => a.number === this.state.dictionaryNumber)) {

            changes.dictionaryNumber = dictionaries[0].number;
        }

        this.setState(changes);
    }

    onDictionaryFieldChange(number: number, fields: DictionaryField[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let target = this.state.reportConfig.dictionaries.find(x => x.number === number) as Dictionary;

        target.fields = fields;

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { dictionaries: this.state.reportConfig.dictionaries } as ReportConfig);

        this.setState(changes);
    }

    onFunctionChange(functions: UserDefinedFunction[], deletedFunctionNumber?: number): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { userDefinedFunctions: functions } as ReportConfig);

        if (functions.length === 0) {

            changes.functionNumber = null;
        }
        else if (!functions.some(a => a.number === this.state.functionNumber)) {

            changes.functionNumber = functions[0].number;
        }

        resetNumbers(changes.reportConfig.userDefinedFunctions);

        this.setState(changes, () => {

            if (deletedFunctionNumber) {
                let config = copyObject(this.state.reportConfig);

                updateFunctionReferencesOnDelete(functions, config, deletedFunctionNumber);

                this.setState({ reportConfig: config });
            }
        });
    }

    onFunctionParameterChange(number: number, parameters: UserDefinedFunctionParameter[]): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let target = this.state.reportConfig.userDefinedFunctions.find(x => x.number === number) as UserDefinedFunction;

        target.parameters = parameters;

        let changes = {} as State;

        changes.reportConfig = Object.assign({}, this.state.reportConfig, { userDefinedFunctions: this.state.reportConfig.userDefinedFunctions } as ReportConfig);

        this.setState(changes);
    }

    onClipboardChange(clipboard: ReportLogicLocation) {

        this.setState({ clipboard: clipboard });
    }

    async save(exit: boolean, changeName?: string, changeComment?: string): Promise<void> {

        this.setState({ errors: [], showChangeNameAndComment: false, isWaiting: true });

        let copy = copyObject(this.state.reportConfig);

        if (this.state.reportConfig.type === reportType.accuracy) {
            this.trimValidationNames(copy.validations);
        }

        let errors = await validate(copy, this.pageContext.collections);

        if (errors.length > 0) {

            this.setState({ showChangeNameAndComment: false, isWaiting: false, reportConfig: copy, errors: errors }, () => reportConfigNavigation.navigateToSection(htmlIds.bottom));

            return Promise.reject('Invalid report config');
        }

        copy.globalModuleConfigId = this.pageContext.collections.globalModuleConfig?.id;

        let url: string = this.prepareUrlOnSave(copy, changeName, changeComment);

        try {
            var res = await httpClient.putSimple(url, copy);

            let message = res.data ? `Config was saved with version ${res.data}.` : 'Config was saved.';

            messageHelper.showMesage(message, true, true);

            await this.saveDescription(copy);

            this.proceedWithExit(exit);
        }
        catch (error) {
            this.onSaveError(error);
        }
    }

    prepareUrlOnSave(config: ReportConfig, changeName?: string, changeComment?: string) {
        let url: string;

        if (config.type !== reportType.globalModule) {
            url = urlHelper.buildRoute(['report', this.id]);
        }
        else {
            url = 'report/global-module';
        }

        url += `?changeName=${changeName || ''}&changeComment=${changeComment || ''}`;

        return url;
    }

    onSaveError(error: any) {

        const unautorizedStatusCode = 401;

        let err = error as any;

        this.setState({ isWaiting: false });

        let response = (err.response || {}) as AxiosResponse<any>;

        if (response.status === unautorizedStatusCode) {
            messageHelper.showMesage('Your session has expired. Please log in again.');
        }
        else {
            messageHelper.showMesage(`${response.data.message}`);
        }
    }


    async saveDescription(config: ReportConfig): Promise<void> {
        if (!typeHelper.isNumber(config.id)) {
            return;
        }

        let url = urlHelper.buildRoute(['report', 'update', 'description']);
        await httpClient.putSimple(url, { id: config.id, description: config.description || '' });
    }

    onExitClick(): void {

        var state = store.getState();

        if (state.action === actions.navigation.setUnsafe) {
            this.setState({ showInformationModal: true, warningModalMessage: leavePageMessage, warningModalTitle: leavePageTitle, onWarningOkClick: this.exit });
        }
        else {
            this.exit();
        }
    }

    exit(): void {

        let route = appRoutes.reporting.home;
        if (this.state.reportConfig.type === reportType.accuracy) {
            route = appRoutes.validation.home;
        }

        history.push(route);

        if (editReportConfigHelper.isValidationConfig(this.state.reportConfig)) {
            lockManager.unlockComponents(this.state.reportConfig.id || 0);
        }
    }

    proceedWithExit(exit: boolean): void {

        let route = appRoutes.reporting.home;

        if (this.state.reportConfig.type === reportType.accuracy) {
            route = appRoutes.validation.home;
        }

        const payload = (): void => {

            if (exit) {
                history.push(route);
            }
            else {
                navigationHelper.refreshPage();
            }
        };

        store.dispatch({ type: actions.navigation.execute, payload: payload });
    }

    onRefreshDataSourcesSuccess(response: AxiosResponse<IngestionConfig[]>): void {

        seedReportDataSources(response.data, this.pageContext);

        this.setState({ isWaiting: false });
    }

    onQuickActionItemSelected(selectedValue: SelectedOptionValue | SelectedOptionValue[]): void {
        this.onQuickActionFieldChange(selectedValue.toString());
    }

    processComponentWhenNotLocked(number: number, reportConfigCopy: ReportConfig, reportConfigComponentLock: ReportConfigComponentLock) {

        let editedComponents = this.state.editedComponents.slice();
        const componentAlreadyLocked = this.state.editedComponents.find(x => x.componentType === reportConfigComponentLock.componentType && x.componentId === reportConfigComponentLock.componentId);
        if (!componentAlreadyLocked) {
            this.setState({ showComponentLockedPopup: false, reportConfig: reportConfigCopy });

            const intervalId = setInterval(() => {
                this.onCheckMinutesUntilLockWillExpire(reportConfigComponentLock.componentId || 0, reportConfigComponentLock.componentType);
            }, this.oneMinutesInMileseconds);

            let editedComponent = { number: number, intervalId, lockedById: 'noone', componentId: reportConfigComponentLock.componentId, componentType: reportConfigComponentLock.componentType || ComponentType.None, reportConfigId: this.state.reportConfig.id || 0 };
            editedComponents.push(editedComponent);
        }
        return editedComponents;
    }

    determinateComponent(reportConfigComponentLock: ReportConfigComponentLock, reportConfig: ReportConfig) {
        let component;
        switch (reportConfigComponentLock.componentType) {
            case ComponentType.Variable: component = reportConfig.variables.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.Lookup: component = reportConfig.lookups.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.LeiSelector: component = reportConfig.leiSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.ExchangeRatesSelector: component = reportConfig.exchangeRatesSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.AnnaDsbUpiEnrichmentSelector: component = reportConfig.annaDsbUpiEnrichmentSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.AnnaDsbUpiSelector: component = reportConfig.annaDsbUpiSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.LseSelector: component = reportConfig.lseSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.SymbolSelector: component = reportConfig.symbolSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.FCARegulatedEntitiesSelector: component = reportConfig.fcaRegulatedEntitiesSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.FirdsEsmaInstrumentSelectors: component = reportConfig.firdsEsmaInstrumentSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.FirdsFcaInstrumentSelectors: component = reportConfig.firdsFcaInstrumentSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.IsinSelector: component = reportConfig.isinSelectors.find(v => v.id === reportConfigComponentLock.componentId); break;
            case ComponentType.AccuracyValidation: component = reportConfig.validations.find(v => v.id === reportConfigComponentLock.componentId); break;
            default: break;
        }
        return component;
    }

    async onComponentContainerClick(reportConfigComponentLock: ReportConfigComponentLock): Promise<boolean> {

        if (reportConfigComponentLock?.componentId && reportConfigComponentLock?.componentId > 0 && editReportConfigHelper.isValidationConfig(this.state.reportConfig)) {

            const componentAlreadyLocked = this.state.editedComponents.find(x => x.componentType === reportConfigComponentLock.componentType && x.componentId === reportConfigComponentLock.componentId);

            if (!componentAlreadyLocked) {

                let isValidJsonConfig = this.validateThatComponentsBeforeLock();

                if (isValidJsonConfig) {
                    let reportConfigCopy = Object.assign({}, this.state.reportConfig);


                    let component = this.determinateComponent(reportConfigComponentLock, reportConfigCopy);

                    if (component && !component.isUsedByCurrentUser) {
                        const result = await lockManager.lockValidationConfigComponent(this.state.reportConfig, { reportConfigId: this.state.reportConfig.id || 0, componentId: reportConfigComponentLock.componentId || 0, componentType: reportConfigComponentLock.componentType || ComponentType.None });

                        this.onLockValidationConfigComponentResult(result, component, reportConfigCopy, reportConfigComponentLock);
                    }
                }
            }
        }
        return false;
    }

    onLockValidationConfigComponentResult(result: ReportConfigLockResponse, component: any, reportConfig: ReportConfig, reportConfigComponentLock: ReportConfigComponentLock) {

        if (result?.lockedBy || result.error) {
            component.isReadOnly = true;
            component.isLocked = true;
            component.isUsedByCurrentUser = false;
            messageHelper.showMesage(result.error || '', false);
            this.setState({ reportConfig: reportConfig });
            return true;
        }
        else {
            component.isUsedByCurrentUser = true;
            component.isReadOnly = false;
            component.isLocked = false;
            let editedComponents = this.processComponentWhenNotLocked(component.number, reportConfig, reportConfigComponentLock);
            this.setState({ editedComponents });
        }
    }

    trimValidationNames(validations: AccuracyValidation[]) {
        validations.forEach((val) => val.identifier = val.identifier.trim())
    }

    validateThatComponentsBeforeLock() {

        let lookupWithoutDataSource2 = Object.assign({}, this.state.reportConfig).lookups.find(l => !l.dataSource2Id);

        if (lookupWithoutDataSource2) {

            let error = `Please set Data Source 2 to lookup ${lookupWithoutDataSource2.name}`;

            if (!lookupWithoutDataSource2.errors.includes(error)) {
                lookupWithoutDataSource2.errors.push(error);
            }

            return false;
        }
    }

    onActionItemsCountChange(actionType: ActionType, componentType: ComponentType, itemId: number) {
        const counts = Object.assign({}, this.state.counts);

        if (componentType === ComponentType.AccuracyValidation) {
            let validationCount = counts.validationActionItemCounts[itemId] || 0;
            counts.validationActionItemCounts[itemId] = actionType === ActionType.Add ? validationCount + 1 : validationCount - 1;
        }
        else if (componentType === ComponentType.Filter) {
            let filterActionItemsCount = counts.filterActionItemCounts[itemId] || 0;
            counts.filterActionItemCounts[itemId] = actionType === ActionType.Add ? filterActionItemsCount + 1 : filterActionItemsCount - 1;
        }
        else if (componentType === ComponentType.Enrichment) {
            let enrichmentActionItemsCount = counts.reportFieldActionItemCounts[itemId] || 0;
            counts.reportFieldActionItemCounts[itemId] = actionType === ActionType.Add ? enrichmentActionItemsCount + 1 : enrichmentActionItemsCount - 1;
        }
        else if (componentType === ComponentType.Case) {
            let caseActionItemsCount = counts.caseActionItemCounts[itemId] || 0;
            counts.caseActionItemCounts[itemId] = actionType === ActionType.Add ? caseActionItemsCount + 1 : caseActionItemsCount - 1;
        };

        this.setState({ counts });
    }

    async onTransferClick() {

        let url = urlHelper.buildRoute(['report', this.id, 'transfer']);

        const resp = await httpClient.get<TransferModel>(url);

        let state: ReportTransferModalState = {
            title: 'Transfer Changes',
            isOpen: true,
            error: null,
            toTransfer: resp.data,
        };

        store.dispatch({ type: actions.transferChangesModal.open, payload: state });
    }

    async onTransferConfirm() {

        let appState = store.getState();
        if (appState.action !== actions.transferChangesModal.save) {
            return;
        }

        let state = appState.transferChangesModalSave;

        let url = urlHelper.buildRoute(['report', this.id, 'transfer']);

        await httpClient.put(url, state.toTransfer).then(
            (resp) => {

                let error = resp.data as string;

                if (error.length > 0) {

                    messageHelper.showMesage(error, true);

                } else {
                    this.proceedWithExit(false);
                }
            });
    }

    onAddGlobalReferencedLookups(lookups: Lookup[], refDataSources: RefDataSource[]): void {

        let collections = this.pageContext.collections;

        refDataSources.forEach((ds) => {
            if (!collections.dataSources.find(x => x.id === ds.id)) {
                collections.dataSources.push({ fieldDefinitions: ds.fieldDefinitions, id: ds.id, dataSourceKind: ds.dataSouceKind as string, name: ds.name as string } as IngestionConfig)
            }
        });

        let config = this.prepareConfigOnAddGlobalReferencedLookups(lookups, collections.dataSources);

        this.setState({ reportConfig: config });
    }

    onDragLookupBetween(numbersMap: Map<number, number>): void {

        let config = copyObject(this.state.reportConfig);

        let newLookups = reorderHelper.changeComponentsNumberOnDragBetween(config.lookups, numbersMap);

        config.lookups = newLookups as Lookup[];

        sortingHelper.sortByNumberAsc(config.lookups as IdNameAndNumber[]);

        editReportConfigHelper.resetErrors(config);

        this.setState({ reportConfig: config }, () => {

            store.dispatch({ type: actions.component.change, payload: { actionType: ActionType.Change, location: reportLogicLocationHelper.createLocation(0, locationType.statement.lookup) as ReportLogicLocation } as ComponentChangeState });

        });
    }

    onDragVariableBetween(numbersMap: Map<number, number>): void {

        let config = copyObject(this.state.reportConfig);

        let newItems = reorderHelper.changeComponentsNumberOnDragBetween(config.variables, numbersMap);

        config.variables = newItems as ReportVariable[];

        sortingHelper.sortByNumberAsc(config.variables as IdNameAndNumber[]);

        editReportConfigHelper.resetErrors(config);

        this.setState({ reportConfig: config }, () => {

            store.dispatch({ type: actions.component.change, payload: { actionType: ActionType.Change, location: reportLogicLocationHelper.createLocation(0, locationType.statement.variable) as ReportLogicLocation } as ComponentChangeState });

        });
    }

    onDragFilterBetween(numbersMap: Map<number, number>): void {

        let config = copyObject(this.state.reportConfig);

        let newItems = reorderHelper.changeComponentsNumberOnDragBetween(config.filters, numbersMap);

        config.filters = newItems as ReportFilter[];

        sortingHelper.sortByNumberAsc(config.filters as IdNameAndNumber[]);

        editReportConfigHelper.resetErrors(config);

        this.setState({ reportConfig: config });
    }

    onDragEndpointFilterBetween(numbersMap: Map<number, number>, filterType: string): void {

        let config = copyObject(this.state.reportConfig);

        let items = this.state.reportConfig.endpointFilters.filter(x => x.type === filterType);

        let newItems = reorderHelper.changeComponentsNumberOnDragBetween(items, numbersMap);

        let otherFilters = copyArray(this.state.reportConfig.endpointFilters).filter(x => x.type !== filterType);

        config.endpointFilters = newItems.concat(otherFilters) as EndpointFilter[];

        sortingHelper.sortByNumberAsc(config.endpointFilters as IdNameAndNumber[]);

        editReportConfigHelper.resetErrors(config);

        this.setState({ reportConfig: config });
    }


    onDragCaseBetween(numbersMap: Map<number, number>): void {

        let config = copyObject(this.state.reportConfig);

        let newItems = reorderHelper.changeComponentsNumberOnDragBetween(config.cases, numbersMap);

        config.cases = newItems as ReportCase[];

        sortingHelper.sortByNumberAsc(config.cases as NumberType[]);

        editReportConfigHelper.resetErrors(config);

        this.setState({ reportConfig: config });
    }

    prepareConfigOnAddGlobalReferencedLookups(lookups: Lookup[], dataSources: IngestionConfig[]): ReportConfig {

        let config = copyObject(this.state.reportConfig);

        config.lookups = lookups;

        config.refDataSources = [];

        dataSources.filter(x => x.id !== config.rawDataSourceId).forEach((ds) => {
            config.refDataSources.push({
                name: ds.name,
                id: ds.id as number,
                dataSouceKind: ds.dataSourceKind,
                runStatus: 0,
                fieldDefinitions: ds.fieldDefinitions
            });
        });

        return config;
    }

    onAddGlobalReferencedVariables(variables: ReportVariable[], lookups: Lookup[], dataSources: RefDataSource[], setup?: (config: ReportConfig) => void): void {

        let collections = this.pageContext.collections;

        dataSources.forEach((ds) => {
            if (!collections.dataSources.find(x => x.id === ds.id)) {
                collections.dataSources.push({ fieldDefinitions: ds.fieldDefinitions, id: ds.id, dataSourceKind: ds.dataSouceKind as string, name: ds.name as string } as IngestionConfig)
            }
        });

        let config = this.prepareConfigOnAddGlobalReferencedLookups(lookups, collections.dataSources);

        config.variables = variables;

        setup && setup(config);

        this.setState({ reportConfig: config });
    }

    onOkInformationPopupClick() {
        if (this.state.onWarningOkClick) {
            this.state.onWarningOkClick();
        }
        else {
            this.setState({ showInformationModal: false });
        }
    }

    onNameChange(e: React.ChangeEvent<HTMLInputElement>): void {

        this.setState({ changesName: e.target.value });
    }

    onCommentChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {

        this.setState({ changesComment: e.target.value });
    }

    onOptionalModuleSelected(module: string) {

        if (!this.state.reportConfig.optionalModules.includes(module)) {

            let config = copyObject(this.state.reportConfig);
            config.optionalModules.push(module);

            store.dispatch({ type: actions.optionalModules.set, payload: config.optionalModules });

            this.setState({ reportConfig: config });
        }
    }

    getOptionalModules() {

        let allModules = getModules();

        return allModules.filter(x => !this.state.reportConfig.optionalModules.includes(x.value));
    }

    onRemoveOptionalModule(module: string) {

        let config = copyObject(this.state.reportConfig);
        config.optionalModules = config.optionalModules.filter(x => x !== module);

        store.dispatch({ type: actions.optionalModules.set, payload: config.optionalModules });

        this.setState({ reportConfig: config });
    }

    async setReportIsLocked() {

        await this.lock();

        const twoMinutesInMileseconds = 120000;

        const intervalId = setInterval(async () => {

            if (!this.state.isWaiting) {
                this.lock();
            }

        }, twoMinutesInMileseconds);

        this.lockIntervalId = intervalId;
    }

    render(): JSX.Element {

        return (
            <>
                <ErrorMessage error={this.state.lockMessage} />

                <ReportConfigEditor
                    onAggregationFilterChange={this.onAggregationFilterChange}
                    onRemoveOptionalModule={this.onRemoveOptionalModule}
                    onOptionalModuleSelected={this.onOptionalModuleSelected}
                    onSymbolelectorSelected={this.onSymbolelectorSelected}
                    isWaiting={this.state.isWaiting}
                    isReadOnly={this.state.isReadOnly}
                    aggregationNumber={this.state.aggregationNumber}
                    isinSelectorNumber={this.state.isinSelectorNumber}
                    symbolSelectorNumber={this.state.symbolSelectorNumber}
                    leiSelectorNumber={this.state.leiSelectorNumber}
                    exchangeRatesSelectorNumber={this.state.exchangeRatesSelectorNumber}
                    annaDsbUpiEnrichmentSelectorNumber={this.state.annaDsbUpiEnrichmentNumber}
                    lseSelectorNumber={this.state.lseNumber}
                    fcaRegulatedEntitiesSelectorNumber={this.state.fcaRegulatedEntitiesNumber}
                    annaDsbUpiSelectorNumber={this.state.annaDsbUpiNumber}
                    caseNumber={this.state.caseNumber}
                    dictionaryNumber={this.state.dictionaryNumber}
                    functionNumber={this.state.functionNumber}
                    collections={this.pageContext.collections}
                    reportConfig={this.state.reportConfig}
                    counts={this.state.counts}
                    clipboard={this.state.clipboard}
                    onAggregationSelected={this.onAggregationSelected}
                    onIsinSelectorSelected={this.onIsinSelectorSelected}
                    onLeiSelectorSelected={this.onLeiSelectorSelected}
                    onExchangeRatesSelectorSelected={this.onExchangeRatesSelectorSelected}
                    onAnnaDsbUpiEnrichmentSelectorSelected={this.onAnnaDsbUpiEnrichmentSelectorSelected}
                    onAnnaDsbUpiSelectorSelected={this.onAnnaDsbUpiSelectorSelected}
                    onFirdsFcaInstrumentSelected={this.onFirdsFcaInstrumentSelectorSelected}
                    onFirdsEsmaInstrumentSelected={this.onFirdsEsmaInstrumentSelectorSelected}
                    onLSESelectorSelected={this.onLSESelectorSelected}
                    onSymbolSelectorSelected={this.onSymbolSelectorSelected}
                    onFCARegulatedEntitiesSelected={this.onFCARegulatedEntitiesSelectorSelected}
                    onCaseSelected={this.onCaseSelected}
                    onDictionarySelected={this.onDictionarySelected}
                    onFunctionSelected={this.onFunctionSelected}
                    onDataSourceChange={this.onDataSourceChange}
                    onAggregationChange={this.onAggregationChange}
                    onAggregatedRecordFieldChange={this.onAggregatedRecordFieldChange}
                    onLookupChange={this.onLookupChange}
                    onIsinSelectorChange={this.onIsinSelectorChange}
                    onLeiSelectorChange={this.onLeiSelectorChange}
                    onExchangeRatesSelectorChange={this.onExchangeRatesSelectorChange}
                    onAnnaDsbUpiEnrichmentSelectorChange={this.onAnnaDsbUpiEnrichmentSelectorChange}
                    onAnnaDsbUpiSelectorChange={this.onAnnaDsbUpiSelectorChange}
                    onLSESelectorChange={this.onLSESelectorChange}
                    onSymbolSelectorChange={this.onSymbolSelectorChange}
                    onFCARegulatedEntitiesSelectorChange={this.onFCARegulatedEntitiesSelectorChange}
                    onFirdsFcaInstrumentChanged={this.onFirdsFcaInstrumentSelectorChange}
                    onFirdsEsmaInstrumentChanged={this.onFirdsEsmaInstrumentSelectorChange}
                    onVariableChange={this.onVariableChange}
                    onFilterChange={this.onFilterChange}
                    onEndpointFilterChange={this.onEndpointFilterChange}
                    onValidationChange={this.onValidationChange}
                    onCaseChange={this.onCaseChange}
                    onEnrichmentChange={this.onEnrichmentChange}
                    onSyncedWithIdChange={this.onSyncedWithIdChange}
                    onMatchingKeyChange={this.onMatchingKeyChange}
                    onMatchingKeyEndPointChange={this.onMatchingKeyEndPointChange}
                    onDictionaryChange={this.onDictionaryChange}
                    onDictionaryFieldChange={this.onDictionaryFieldChange}
                    onFunctionChange={this.onFunctionChange}
                    onFunctionParameterChange={this.onFunctionParameterChange}
                    onClipboardChange={this.onClipboardChange}
                    onLookupConditionUpdated={this.updateLookupDataSourceId}
                    onImportSuccess={() => this.proceedWithExit(false)}
                    errors={this.state.errors}
                    regime={this.state.reportConfig.regime}
                    onComponentContainerClick={this.onComponentContainerClick}
                    onActionItemsCountChange={this.onActionItemsCountChange}
                    onAggregationSyncedWithIdChange={this.onAggregationSyncedWithIdChange}
                    firdsEsmaInstrumentSelectorNumber={this.state.firdsEsmaInstrumentSelectorNumber}
                    firdsFcaInstrumentSelectorNumber={this.state.firdsFcaInstrumentSelectorNumber}
                    onAddGlobalReferencedLookups={this.onAddGlobalReferencedLookups}
                    onAddGlobalReferencedVariables={this.onAddGlobalReferencedVariables}
                    onGlobalModuleDataSourceSelected={this.onGlobalModuleDataSourceSelected}
                    onGlobalModuleDataSourceDeleted={this.onGlobalModuleDataSourceDeleted}
                    onDragLookupBetween={this.onDragLookupBetween}
                    onDragCaseBetween={this.onDragCaseBetween}
                    onDragVariableBetween={this.onDragVariableBetween}
                    onDragFilterBetween={this.onDragFilterBetween}
                    onDragEndpointFilterBetween={this.onDragEndpointFilterBetween}
                />

                <div id={htmlIds.bottom}></div>

                <QuickActions
                    isWaiting={this.state.isWaiting}
                    isReadOnly={this.state.isReadOnly}
                    onSaveClick={async () => this.setState({ shouldExit: false, showChangeNameAndComment: true })}
                    onSaveAndExitClick={async () => this.setState({ shouldExit: true, showChangeNameAndComment: true })}
                    onExitClick={this.onExitClick}>
                    {this.state.reportConfig.type !== reportType.accuracy &&
                        <div className="col-auto">
                            <SelectSearch
                                disabled={this.state.isWaiting}
                                options={buildOptions(this.pageContext.collections.reportFields).map(createSelectSearchOption)}
                                value={this.state.quickActionNumber}
                                search={true}
                                onChange={this.onQuickActionItemSelected} />
                        </div>
                    }
                    {this.state.reportConfig.type === reportType.accuracy &&
                        !this.state.isWaiting &&
                        <div className="col-auto">
                            <button className="btn cb-btn" onClick={this.onTransferClick}>Transfer</button>
                        </div>
                    }
                </QuickActions>
                <OperandModal
                    regime={this.state.reportConfig.regime}
                    reportType={this.state.reportConfig.type}
                    collections={this.pageContext.collections}
                    userDefinedFunctions={this.state.reportConfig.userDefinedFunctions}
                    dictionaries={this.state.reportConfig.dictionaries}
                    lookups={this.state.reportConfig.lookups}
                    variables={this.state.reportConfig.variables}
                    isinSelectors={this.state.reportConfig.isinSelectors}
                    leiSelectors={this.state.reportConfig.leiSelectors}
                    cases={this.state.reportConfig.cases}
                    aggregations={this.state.reportConfig.aggregations}
                    exchangeRatesSelectors={this.state.reportConfig.exchangeRatesSelectors} />

                {this.state.reportConfig.type !== reportType.globalModule &&
                    <>
                        <CopyReportFieldModal fields={this.pageContext.collections.reportFields} cases={this.state.reportConfig.cases} />

                        <CopyAggregationModal
                            aggregations={this.state.reportConfig.aggregations}
                            fieldDefinitions={this.pageContext.collections.dataSources.find(x => x.dataSourceKind === dataSourceKind.raw)?.fieldDefinitions || []}
                            variables={this.state.reportConfig.variables} />

                        {this.state.reportConfig.type === reportType.accuracy &&
                            <CopyValidationModal validations={this.state.reportConfig.validations} />
                        }
                    </>
                }

                <CopyVariableModal variables={this.state.reportConfig.variables} />

                <ReportTransferModal />

                {this.state.showInformationModal &&
                    <InformationModal
                        onOkClick={this.onOkInformationPopupClick}
                        title={this.state.warningModalTitle}
                        message={this.state.warningModalMessage}
                    />
                }

                {this.state.showChangeNameAndComment &&

                    <ChangeLogNameAndCommentModal
                        title='Change Name and Comment'
                        defaultComment=''
                        defaultName=''
                        onSaveClick={(name: string, comment: string) => this.save(this.state.shouldExit, name, comment)}
                        onClose={() => this.setState({ showChangeNameAndComment: false })} />
                }
                <MoreArgumentsModal />
            </>
        );
    }
}

export default ReportEditPage;